import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="tom-select"
export default class extends Controller {
  static values = {
    maxItems: { type: Number, default: 1 },
    placeholder: String,
    url: String,
    searchParam: { type: String, default: "q" },
    valueField: { type: String, default: "name" },
    labelField: { type: String, default: "name" },
  };

  connect() {
    this.initializeTomSelect();
  }

  disconnect() {
    this.destroyTomSelect();
  }

  initializeTomSelect() {
    if (!this.element) return;

    const options = {
      maxItems: this.maxItemsValue,
      selectOnTab: true,
      closeAfterSelect: true,
      hidePlaceholder: true,
      placeholder: this.placeholderValue || "",
      create: false,
      openOnFocus: true,
      highlight: true,
    };

    if (this.hasUrlValue) {
      options.valueField = this.valueFieldValue;
      options.labelField = this.labelFieldValue;
      options.searchField = this.labelFieldValue;
      options.loadThrottle = 250;
      options.preload = "focus";
      options.load = async (query, callback) => {
        try {
          const url = new URL(this.urlValue, window.location.origin);
          url.searchParams.set(this.searchParamValue, query);

          const response = await fetch(url);
          if (!response.ok) return callback([]);

          callback(await response.json());
        } catch (error) {
          console.error(error);
          callback([]);
        }
      };
    }

    this.select = new TomSelect(this.element, options);
  }

  destroyTomSelect() {
    if (this.select) {
      this.select.destroy();
    }
  }
}
